import initBlogMenu from '@PROJECT_ROOT/assets/mobile/js/blog/menu';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';

const state = fetchStateFromHtml();

$(() => {
    initBlogMenu(state);
});
